import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const OvernightBus = t0 => {
  const $ = _c(9);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path fillRule="evenodd" clipRule="evenodd" d="M19 4.80095C19 4.0847 18.4419 3.97195 18.1136 4.00511H6.88636C6.59091 4.00512 6 4.16429 6 4.80095V7.34724H19V4.80095ZM6 11.2867V8.90779H11.7197V11.2867H6ZM13.2803 11.2867H19V8.90779H13.2803V11.2867ZM6 12.8472H19V18.1312C19 18.6087 18.6061 18.7281 18.4091 18.7281H6.59091C6.11818 18.7281 6 18.3302 6 18.1312V12.8472ZM10.9242 15.3713C10.9242 16.1954 10.2628 16.8635 9.44697 16.8635C8.63109 16.8635 7.9697 16.1954 7.9697 15.3713C7.9697 14.5471 8.63109 13.8791 9.44697 13.8791C10.2628 13.8791 10.9242 14.5471 10.9242 15.3713ZM17.0303 15.3713C17.0303 16.1954 16.3689 16.8635 15.553 16.8635C14.7372 16.8635 14.0758 16.1954 14.0758 15.3713C14.0758 14.5471 14.7372 13.8791 15.553 13.8791C16.3689 13.8791 17.0303 14.5471 17.0303 15.3713ZM13.9581 5.06907L13.879 5.06516H11.1212C10.6904 5.06516 10.3409 5.41465 10.3409 5.84544C10.3409 6.27622 10.6904 6.62571 11.1212 6.62571H13.879L13.9581 6.6218C14.3517 6.58207 14.6583 6.24945 14.6583 5.84544C14.6583 5.44143 14.3517 5.10881 13.9581 5.06907Z" />;
    t2 = <path d="M15 18.9615V20.7007C15 20.9094 15.2917 20.9615 15.375 20.9615H17.625C17.75 20.9615 18 20.9094 18 20.7007V18.9615" />;
    t3 = <path d="M7 18.9615V20.7007C7 20.9094 7.29167 20.9615 7.375 20.9615H9.625C9.75 20.9615 10 20.9094 10 20.7007V18.9615" />;
    t4 = <path d="M22 5V4.45143L23.3633 2.54857H22.0108V2H24V2.54857L22.6367 4.45143H23.9892V5H22Z" />;
    t5 = <path d="M21 9V8.45143L22.3633 6.54857H21.0108V6H23V6.54857L21.6367 8.45143H22.9892V9H21Z" />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== props) {
    t6 = <IconWrapper {...props} variant="solid" viewBox="0 0 25 25">{t1}{t2}{t3}{t4}{t5}</IconWrapper>;
    $[7] = props;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};
export { OvernightBus };